import { IHierarchicalDepartmentDTO, ITypeaheadRequestDTO } from 'src/api/dtos';
import CommonRepository from 'src/api/repositories/common/common.repository';
import api from 'src/api/rtk/rtk-api';
import { IListQueryResult } from 'src/api/types';

export default class CommonDepartmentRepository extends CommonRepository {
  private static readonly baseRoute = '/departments';
  private static readonly apiURL = CommonDepartmentRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public static endpoints = api.injectEndpoints({
    overrideExisting: true,
    endpoints: (build) => ({
      getDepartments: build.query<IHierarchicalDepartmentDTO[], ITypeaheadRequestDTO>({
        query: (params) => {
          return { url: this.apiURL, method: 'get', params };
        },
        transformResponse: (response: IListQueryResult<IHierarchicalDepartmentDTO>) => response.items,
        providesTags: [{ type: 'Departments' }],
      }),
    }),
  });
}
